/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-program-creation';

type PropsFromCaller = {
  limit: number;
  count: number;
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
};

type Props = PropsFromCaller;

/**
 * @deprecated enterprise-ui use CDS TextField instead
 */
export const CharacterCounter: React.FC<Props> = ({ limit, count, align = 'inherit' }) => {
  return (
    <Typography2 component="p" variant="bodyPrimary" color="supportText" align={align}>
      <FormattedMessage
        message={_t('{remainingChars} {remainingChars, plural, =1 {character} other {characters}} left')}
        remainingChars={limit - count === 0 ? '0' : limit - count}
      />
    </Typography2>
  );
};
